import * as React from "react";
import Shop from "../../_data/models/Shop";
import {Redirect} from "react-router";
import {ShopsRoutes, UsersRoutes} from "../../routes";
import BreadcrumbsComponent from "../../_widgets/breadcrumbs/BreadcrumbsComponent";
import ShopBoothsContainer from "../container/ShopBoothsContainer";
import ShopProfessionalsContainer from "../container/ShopProfessionalsContainer";
import {Link} from "react-router-dom";
import User from "../../_data/models/User";
import {ActiveModalState} from "../../_definitions/styleteq";
import ShopMapModalComponent from "./ShopMapModalComponent";
import CarouselComponent from "../../_widgets/carousel/CarouselComponent";

interface Props {
    shop: Shop;
    shopOwner: User;
    toggleMapModal: (state: ActiveModalState) => void;
    activeModal: ActiveModalState;
}

const ShopViewComponent = (props: Props) => {

    const {shop, shopOwner, toggleMapModal, activeModal} = props;

    if (!shop) {
        return <Redirect to={{pathname: ShopsRoutes.index(), state: {refresh: true}}}/>
    }

    return (
        <div>
            <div className="row expanded">
                <BreadcrumbsComponent>
                    <li>
                        <a href="javascript: history.go(-1)">
                            Back
                        </a>
                    </li>
                    <li>
                        {shop.name}
                    </li>
                </BreadcrumbsComponent>

            </div>

            <div className="row expanded">
                <div className="large-12 columns">
                    <div className="text-group mt-1 mb-1">
                        <h4>{shop.name}</h4>

                        <p className="subheader"><i className="fa fa-heart"></i>&nbsp; {shop.likeCount} Followers</p>
                    </div>
                </div>
            </div>

            <div className="row expanded">
                <div className="large-12 columns">
                    <CarouselComponent images={shop.images} />
                </div>
            </div>

            <div className="row expanded">
                <div className="large-12 columns">
                    <div className="flex-container">
                        <div className="media-object">
                            <div className="media-object-section logo middle">
                                <div className="img-wrapper circle">
                                    <img src={shopOwner.profilePicture()}/>
                                </div>
                            </div>
                            <div className="media-object-section middle">
                                <span className="h4">{shopOwner && shopOwner.username()}</span>
                                <p className="subheader"><small>{shop.address()}&nbsp; <a href="#" onClick={(e) => { e.preventDefault(); toggleMapModal(activeModal); }}>View Map</a></small></p>
                                <ShopMapModalComponent active={activeModal.active} close={() => {toggleMapModal(activeModal)}} shop={shop} />
                            </div>
                        </div>
                        <Link to={UsersRoutes.show(shop.userId)} className="button primary hollow small pull-right">
                            View Profile
                        </Link>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="large-12 columns">
                    <h6 className="page-lead">Booths For Rent</h6>

                    <ShopBoothsContainer shop={shop} />
                </div>
            </div>

            <div className="row">
                <div className="large-12 columns">
                    <h6 className="page-lead">Professionals</h6>
                    <ShopProfessionalsContainer shop={shop} />
                </div>
            </div>

        </div>
    );
};

export default ShopViewComponent;


// WEBPACK FOOTER //
// ./app/client/shop/components/ShopViewComponent.tsx